const types = {
  SET_HIGHLIGHTED_BLOCKS: 'SET_HIGHLIGHTED_BLOCKS',
  CLEAR_HIGHLIGHTED_BLOCKS: 'CLEAR_HIGHLIGHTED_BLOCKS',
  SET_SCROLL_TO_PAGE: 'SET_SCROLL_TO_PAGE',
};

const state = {
  highlightedBlockNumbers: [], // Array of block numbers to highlight
  scrollToPage: false, // Flag to trigger auto-scroll to page with smallest box number
};

const getters = {
  highlightedBlockNumbers: appState => appState.highlightedBlockNumbers,
  scrollToPage: appState => appState.scrollToPage,
};

const mutations = {
  [types.SET_HIGHLIGHTED_BLOCKS](appState, blockNumbers) {
    appState.highlightedBlockNumbers = blockNumbers || [];
  },
  [types.CLEAR_HIGHLIGHTED_BLOCKS](appState) {
    appState.highlightedBlockNumbers = [];
  },
  [types.SET_SCROLL_TO_PAGE](appState, value) {
    appState.scrollToPage = value;
  },
};

const actions = {
  highlightBlocks({ commit }, blockNumbers) {
    commit(types.SET_HIGHLIGHTED_BLOCKS, blockNumbers);
    commit(types.SET_SCROLL_TO_PAGE, true);
  },
  clearHighlights({ commit }) {
    commit(types.CLEAR_HIGHLIGHTED_BLOCKS);
  },
  setScrollToPage({ commit }, value) {
    commit(types.SET_SCROLL_TO_PAGE, value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
